module.exports = __webpack_public_path__ + "img/img_default_nothing@2x.bc0697b0.png";